import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import {UsePost, UsePut} from "../../hooks/http";
import Form from "./Form";
import {useNavigate} from "react-router-dom";


const Create = ({id}) => {

    const navigate = useNavigate()
    const [errors, setErrors] = useState()
    const [audiences, setAudiences] = useState()
    const [isLoading, setIsLoading] = useState(true)


    const GetAudiences = async () => {
        return await UsePut(
            `/audiences/get`,
            {data: {offset: 0}, toArray: true, propLabel: 'name'}
        )

    }


    useEffect(() => {
        GetAudiences().then((response) => {
            setAudiences(response)
            setIsLoading(false)
        })
    }, [])


    const handleUpdate = (PostData) => {
        setIsLoading(true)
        UsePost(
            `/journeys/upsert`,
            {data: PostData}
        ).then((response) => {
            window.setTimeout(() => {
                if (response.code >= 200 && response.code <= 299) {
                    navigate(`/journeys/${response._id}/builder`)
                    setErrors(undefined)
                } else {
                    setErrors(response.errors)
                }
                setIsLoading(false)
            }, 1500)
        })
    }


    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <Form audiences={audiences} errors={errors} isReady={!isLoading} onSubmit={handleUpdate}/>
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Create